import { useMutation, useQuery } from "@tanstack/react-query";
import { createFeedClaimWeb, createFeedCommentClaimWeb, createFeedCommentLikeWeb, createFeedCommentWeb, createFeedLikeWeb, deleteFeedCommentLikeWeb, deleteFeedLikeWeb, getAllGetFeedListWebResponseByMemberId, getFeedListWeb, updateFeedCommentWeb } from "../../../../../service/feed";

const useGetFeedListWeb = () => {
    const query = useQuery({
        queryKey: ['feedList'],
        queryFn: getFeedListWeb,
        select: (res) => res.data,
    });
    return query
}

const useGetAllGetFeedListWebResponseByMemberId = (enabled: boolean = true) => {
    const query = useQuery({
        queryKey: ['feedList', 'getAllGetFeedListWebResponseByMemberId'],
        queryFn: getAllGetFeedListWebResponseByMemberId,
        select: (res) => res.data,
        enabled: !!enabled
    });
    return query
}

const useCreateFeedLikeWeb = () => {
    const mutation = useMutation({ mutationFn: createFeedLikeWeb });
    return mutation;
}

const useDeleteFeedLikeWeb = () => {
    const mutation = useMutation({ mutationFn: deleteFeedLikeWeb });
    return mutation;
}

const useCreateFeedClaimWeb = () => {
    const mutation = useMutation({ mutationFn: createFeedClaimWeb });
    return mutation;
}

const useCreateFeedCommentWeb = () => {
    const mutation = useMutation({ mutationFn: createFeedCommentWeb });
    return mutation;
}

const useUpdateFeedCommentWeb = () => {
    const mutation = useMutation({ mutationFn: updateFeedCommentWeb });
    return mutation;
}

const useCreateFeedCommentClaimWeb = () => {
    const mutation = useMutation({ mutationFn: createFeedCommentClaimWeb });
    return mutation;
}

const useCreateFeedCommentLikeWeb = () => {
    const mutation = useMutation({ mutationFn: createFeedCommentLikeWeb });
    return mutation;
}

const useDeleteFeedCommentLikeWeb = () => {
    const mutation = useMutation({ mutationFn: deleteFeedCommentLikeWeb });
    return mutation;
}

export { useGetFeedListWeb, useCreateFeedLikeWeb, useDeleteFeedLikeWeb, useCreateFeedClaimWeb, useCreateFeedCommentWeb, useUpdateFeedCommentWeb, useCreateFeedCommentClaimWeb, useCreateFeedCommentLikeWeb, useDeleteFeedCommentLikeWeb, useGetAllGetFeedListWebResponseByMemberId }